import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { content } from "./data/content";
import { SmoothScroll } from "./components/SmoothScroll";
import { GrainOverlay } from "./components/GrainOverlay";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { MarqueeStrip } from "./components/Marquee";
import { Manifesto } from "./components/Manifesto";
import { AboutTeam } from "./components/AboutTeam";
import { Services } from "./components/Services";
import { MarketAnalysis } from "./components/MarketAnalysis";
import { Contacts } from "./components/Contacts";
import { Footer } from "./components/Footer";

const Home = () => {
  return (
    <SmoothScroll>
      <div className="bg-[#0A0A0A] text-[#F4F4F0] min-h-screen">
        <GrainOverlay />
        <Nav />
        <main data-testid="main-content">
          <Hero />
          <MarqueeStrip />
          <Manifesto />
          <AboutTeam />
          <Services />
          <MarketAnalysis />
          <Contacts />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
};

function App() {
  return (
    <LanguageProvider dictionary={content}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
